import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import BulkShipmentBox from "./bulk-shipment-box.model";

export default class BulkShipmentBoxFactory
  implements ObjectBuilderInterface<BulkShipmentBox> {
  public buildFromJSON(data: { [key: string]: any }): BulkShipmentBox {
    const value = new BulkShipmentBox(
      data.id,
      data.boxNumber,
      data.length,
      data.width,
      data.height,
      data.weight
    );

    value.isNew = false;

    return value;
  }
}
